import * as THREE from 'three'
import React, { useMemo } from 'react'
import { params } from '../../../../../../redux/reducers/reducer';
import { extrudeSettings } from '../../../../../../utils/Functions';


const DoubleSliderDoor = ({ width, height, trimWidth, doorColor, isOverlap, overlapTrimColor }) => {
    const trimColor = useMemo(() => {

        return params.p_t_c.replace('0x', '#');
    }, [params.p_t_c])

    const angle1 = Math.atan( (width / 2 - trimWidth * 2) / (height / 2 - trimWidth * 2 - trimWidth / 2))
    const angle2 = Math.PI / 2 - angle1
    const railHeight = (trimWidth / 2) / Math.atan(angle1)
    const railWidth = (trimWidth / 2) / Math.atan(angle2)
    
    const trimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-width / 2,  -height / 2);
        model.lineTo(-width / 2,  height / 2);
        model.lineTo(width / 2,  height / 2);
        model.lineTo(width / 2,  -height / 2);
        model.closePath();

        const hole = new THREE.Path();
        hole.moveTo(-(width / 2 - trimWidth),  -(height / 2 - trimWidth * 2));
        hole.lineTo(-(width / 2 - trimWidth),  height / 2 - trimWidth * 2);
        hole.lineTo(width / 2 - trimWidth,  height / 2 - trimWidth * 2);
        hole.lineTo(width / 2 - trimWidth,  -(height / 2 - trimWidth * 2));
        hole.closePath();

        model.holes.push(hole);

        return model;
    }, [width, height, trimWidth])

    const TopTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-width / 1.5,  height / 2);
        model.lineTo(-width / 1.5,  height / 2 + trimWidth * 2);
        model.lineTo(width / 1.5,  height / 2 + trimWidth * 2);
        model.lineTo(width / 1.5,  height / 2);
        model.closePath();

        return model;
    }, [width, height, trimWidth])
    
    const colRailModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-width / 2, -trimWidth / 2);
        model.lineTo(width / 2, -trimWidth / 2);
        model.lineTo(width / 2, trimWidth / 2);
        model.lineTo(-width / 2, trimWidth / 2);

        return model;
    }, [width, trimWidth])

    const rolRailModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-trimWidth, -height / 2);
        model.lineTo(trimWidth, -height / 2);
        model.lineTo(trimWidth, height / 2);
        model.lineTo(-trimWidth, height / 2);

        return model;
    }, [width, trimWidth, height])
        
    const patternOneModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-width / 2 + trimWidth, height / 2 - trimWidth * 2);
        model.lineTo(-width / 2 + trimWidth + railWidth, height / 2 - trimWidth * 2);
        model.lineTo(-trimWidth, trimWidth / 2 + railHeight);
        model.lineTo(-trimWidth, trimWidth / 2);
        model.lineTo(-trimWidth - railWidth , trimWidth / 2);
        model.lineTo(-width / 2 + trimWidth, height / 2 - trimWidth * 2 - railHeight);
        model.closePath();

        return model;
    }, [width, trimWidth, railWidth, height, railHeight])

    const patternTwoModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-width / 2 + trimWidth, trimWidth / 2);
        model.lineTo(-width / 2 + trimWidth + railWidth, trimWidth / 2);
        model.lineTo(-trimWidth, height / 2 - trimWidth * 2 - railHeight);
        model.lineTo(-trimWidth, height / 2 - trimWidth * 2);
        model.lineTo(-trimWidth - railWidth , height / 2 - trimWidth * 2);
        model.lineTo(-width / 2 + trimWidth, trimWidth / 2 + railHeight);
        model.closePath();

        return model;
    }, [width, trimWidth, railWidth, height, railHeight])

    const doorInsideModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-(width / 2 - trimWidth / 2),  -(height / 2 - trimWidth * 2));
        model.lineTo(-(width / 2 - trimWidth / 2),  height / 2 - trimWidth * 2);
        model.lineTo(width / 2 - trimWidth / 2,  height / 2 - trimWidth * 2);
        model.lineTo(width / 2 - trimWidth / 2,  -(height / 2 - trimWidth * 2));
        model.closePath();

        return model;
    }, [width, height, trimWidth])
    
    return (
        <>
            <mesh name='trim'>
                <extrudeGeometry args={[trimModel, extrudeSettings(0.32)]} />
                <meshStandardMaterial side={THREE.DoubleSide} color={isOverlap ? overlapTrimColor : trimColor} roughness={0.5} metalness={0.2} emissive={'#101010'} toneMapped={false} />
            </mesh>
            {/* <mesh name='top-trim'>
                <extrudeGeometry args={[TopTrimModel, extrudeSettings(0.32)]} />
                <meshStandardMaterial side={THREE.DoubleSide} color={isOverlap ? overlapTrimColor : trimColor} roughness={0.5} metalness={0.2} emissive={'#101010'} toneMapped={false} />
            </mesh> */}
            <mesh name='col-rail'>
                <extrudeGeometry args={[colRailModel, extrudeSettings(0.32)]} />
                <meshStandardMaterial  color={trimColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} />
            </mesh>
            <mesh name='rol-rail'>
                <extrudeGeometry args={[rolRailModel, extrudeSettings(0.32)]} />
                <meshStandardMaterial  color={trimColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} />
            </mesh>

            <mesh name='door-inside' >
                <extrudeGeometry args={[doorInsideModel, extrudeSettings(0.32)]} />
                <meshStandardMaterial color={doorColor} side={THREE.DoubleSide} opacity={0.01} transparent/>
            </mesh>
    
            <>
                {new Array(2).fill('').map((_, indexI) => 
                    new Array(2).fill("").map((_, indexJ) => 
                        <group key={`pattern-model-${indexI}-${indexJ}`} position={[width / 2 * indexI, -(height / 2 - trimWidth - trimWidth / 2) * indexJ, 0]}>
                            <mesh name='pattern-one'>
                                <extrudeGeometry args={[patternOneModel, extrudeSettings(0.32)]} />
                                <meshStandardMaterial  color={trimColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} />
                            </mesh>
                            <mesh name='pattern-two'>
                                <extrudeGeometry args={[patternTwoModel, extrudeSettings(0.32)]} />
                                <meshStandardMaterial  color={trimColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} />
                            </mesh>
                        </group>
                    )
                )}
            </>
        </>
    )
}

export default DoubleSliderDoor